import base from './base';

export const select = (value: any) => base(value);

export default select;
